import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import editor from "./plugins/editor";
import axios from "axios";
import { enviar } from "./mixins/RequisicaoMixin.js";
import { headersLogin } from "./mixins/HeadersMixin.js";
import { googleApi } from "./mixins/GoogleApiMixin.js";
import crypto from "./crypto";

axios.defaults.baseURL = process.env.VUE_APP_API_BACKEND;
Vue.config.productionTip = false;
export const bus = new Vue();

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.message.indexOf("403") > -1) {
      let requestConfig = error.config;
      let token = await refreshToken()
        .then(async (s) => {
          if (!s) {
            localStorage.clear();
            router.push("/");
            return Promise.reject("Sessão encerrada.");
          } else {
            return s;
          }
        })
        .catch((e) => {
          return Promise.reject(e);
        });
      const request = new Promise((resolve) => {
        requestConfig.headers = {};
        requestConfig.headers.Authorization = `Bearer ${token}`;
        resolve(axios(requestConfig));
      });
      return request;
    } else {
      return Promise.reject(error);
    }
  }
);

async function refreshToken() {
  return new Promise((resolve) => {
    let usuarioLogado = JSON.parse(localStorage.getItem("usuarioLogado"));
    if (usuarioLogado.logadoGoogle) {
      googleApi().then(() => {
        const authInstance = window.gapi.auth2.getAuthInstance();
        authInstance.currentUser
          .get()
          .reloadAuthResponse()
          .then((t) => {
            usuarioLogado.token = t.id_token;
            localStorage.setItem(
              "usuarioLogado",
              JSON.stringify(usuarioLogado)
            );
            resolve(t.id_token);
          })
          .catch((e) => {
            console.log(e);
            resolve(false);
          });
      });
    } else {
      const cabecalho = headersLogin();
      enviar("/api/v1/auth", cabecalho, {
        email: usuarioLogado.email,
        senha: crypto.descriptografar(usuarioLogado.ss),
      })
        .then((s) => {
          usuarioLogado.token = s.token;
          localStorage.setItem("usuarioLogado", JSON.stringify(usuarioLogado));
          resolve(s.token);
        })
        .catch(() => {
          return resolve(false);
        });
    }
  });
}

new Vue({
  router,
  store,
  vuetify,
  editor,
  render: (h) => h(App),
}).$mount("#app");
